// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LanguageTogeler_container__2b3pu {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.LanguageTogeler_eachLan__eJhay {
  padding: 5px 10px;
  cursor: pointer;
  font-size: var(--normal-text-size);
  line-height: var(--normal-text-line-height);
  font-weight: var(--normal-text-weight);
}
.LanguageTogeler_active__Kz8Bq {
  font-size: var(--big-text-size);
  line-height: var(--normal-text-line-height);
  font-weight: var(--big-text-weight);
  color: #d6e9f5;
  border-bottom: 2px solid #3684b7cc;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Layout/ThemeConstElements/LanguageTogeler.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,2CAA2C;EAC3C,sCAAsC;AACxC;AACA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mCAAmC;EACnC,cAAc;EACd,kCAAkC;AACpC","sourcesContent":[".container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n.eachLan {\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  font-size: var(--normal-text-size);\r\n  line-height: var(--normal-text-line-height);\r\n  font-weight: var(--normal-text-weight);\r\n}\r\n.active {\r\n  font-size: var(--big-text-size);\r\n  line-height: var(--normal-text-line-height);\r\n  font-weight: var(--big-text-weight);\r\n  color: #d6e9f5;\r\n  border-bottom: 2px solid #3684b7cc;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LanguageTogeler_container__2b3pu`,
	"eachLan": `LanguageTogeler_eachLan__eJhay`,
	"active": `LanguageTogeler_active__Kz8Bq`
};
export default ___CSS_LOADER_EXPORT___;
